import * as Yup from 'yup';
import { Producer } from '../../types';
import { isXlsxFile } from '../../utils/is-xlsx-file.util';

export const catalogFormInitialValues = {
  startPageIndex: null,
  endPageIndex: null,
  catalogFile: null,
  catalogInputType: null as 'pdf' | 'excel' | null,
  producerName: null,
  catalogVariant: null,
  vatPercent: 8,
  purpose: 'Korekcyjne',
  merchandiseType: 'Soczewki Okularowe'
}

const isPdfInput = (catalogInputType: string | null) => catalogInputType === 'pdf';

export const catalogFormValidationSchema = Yup.object().shape({
  startPageIndex: Yup.number()
    .nullable()
    .when('catalogInputType', {
      is: isPdfInput,
      then: (schema) => schema.required('Podaj stronę początkową'),
      otherwise: (schema) => schema.notRequired(),
    }),
  endPageIndex: Yup
    .number()
    .nullable()
    .when('catalogInputType', {
      is: isPdfInput,
      then: (schema) => schema.required('Podaj stronę końcową'),
      otherwise: (schema) => schema.notRequired(),
    }),
  catalogFile: Yup.mixed()
    .nullable()
    .required('Dodaj plik')
    .test(
      'file-size',
      'Plik nie może być większy niż 50mb',
      (value) => !value || (value as File).size <= 50 * 1024 * 1024
    )
    .test(
      'shamir-file-format',
      'Dla Shamir dodaj plik .xlsx',
      function (value) {
        if (this.parent.producerName !== Producer.SHAMIR || !value) {
          return true;
        }

        return isXlsxFile(value as File);
      }
    ),
  catalogInputType: Yup.string()
    .nullable()
    .when('catalogFile', {
      is: (value: File | null) => !!value,
      then: (schema) => schema.oneOf(['pdf', 'excel'], 'Nieobsługiwany typ pliku').required(),
      otherwise: (schema) => schema.notRequired(),
    }),
  producerName: Yup.string()
    .required('Podaj nazwę producenta')
    .max(100, 'Nazwa producenta nie może być dłuższa niż 100 znaków'),
  catalogVariant: Yup.string()
    .when('producerName', {
      is: (value: string | null) => !!value,
      then: (schema) => schema.required('Podaj wariant'),
      otherwise: (schema) => schema.notRequired()
    }),
  vatPercent: Yup.number()
    .nullable()
    .required('Podaj stawkę VAT')
    .min(0, 'Stawka VAT nie może być niższa niż 0'),
  purpose: Yup.string()
    .nullable()
    .required('Podaj przeznaczenie')
    .max(100, 'Przeznaczenie nie może być dłuższe niż 100 znaków'),
  merchandiseType: Yup.string()
    .nullable()
    .required('Dodaj typ towaru')
    .max(100, 'Typ towaru nie może być dłuższy niż 100 znaków')
})
